import { render, staticRenderFns } from "./DesempenhoPorAcs.vue?vue&type=template&id=386c4f52"
import script from "./DesempenhoPorAcs.vue?vue&type=script&lang=js"
export * from "./DesempenhoPorAcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports